export default __webpack_public_path__ + "static/media/marker_active.610e76de.svg";